import { LazyComponent } from '../lazy-components';

const registry = new Map<number, LazyComponent>();

export function registerComponent(pageName: number, resolver: () => Promise<any>): void {
  registry.set(pageName, new LazyComponent(resolver));
}

export function getComponent(pageName: number): LazyComponent | undefined {
  return registry.get(pageName);
}
